import { RefreshCw } from 'lucide-react';

interface PullToRefreshIndicatorProps {
  pullDistance: number;
  isPulling: boolean;
  isRefreshing: boolean;
  shouldTrigger: boolean;
}

export const PullToRefreshIndicator = ({
  pullDistance,
  isPulling,
  isRefreshing,
  shouldTrigger
}: PullToRefreshIndicatorProps) => {
  if (!isPulling && !isRefreshing) return null;

  const opacity = Math.min(pullDistance / 60, 1);
  const scale = Math.min(pullDistance / 80, 1);

  return (
    <div 
      className="fixed top-0 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-200"
      style={{
        transform: `translateX(-50%) translateY(${Math.min(pullDistance - 20, 40)}px)`,
        opacity
      }}
    >
      <div 
        className="bg-win95-gray border-2 border-win95-black rounded-full p-3 shadow-lg"
        style={{ transform: `scale(${scale})` }}
      >
        <RefreshCw 
          className={`h-6 w-6 text-win95-black ${
            isRefreshing || shouldTrigger ? 'animate-spin' : ''
          }`} 
        />
      </div>
      
      {shouldTrigger && !isRefreshing && (
        <div className="text-center mt-2 text-xs text-win95-black font-bold">
          Release to refresh
        </div>
      )}
      
      {isRefreshing && (
        <div className="text-center mt-2 text-xs text-win95-black font-bold">
          Refreshing...
        </div>
      )}
    </div>
  );
};